import axios from "axios";
import { getApiConfig } from "../../apiConfig";


export async function GetIncidentFindResponsible({ company, category, workplace }) {
  try {
    const apiConfig = await getApiConfig();

    // Generar la URL con los parámetros opcionales
    let req = `${apiConfig.BASE_URL}incident/findresponsible?category=${category}&company=${company}`;

    if (workplace) {
      req += `&workplace=${workplace}`;
    }

    const response = await axios.get(req, apiConfig.HEADERS_CONFIG);
    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
